import React from 'react';
import Span from '../../Texts/Span/Span';
import * as S from './CardNumberFormatter.styles';

export const CardNumberFormatter = ({ cell, formatExtraData }) => {
  if (cell) {
    const cardNumber = cell.slice(-8);
    const cardNumberPart1 = cardNumber.slice(0, -4);
    const cardNumberPart2 = cardNumber.slice(-4);

    return (
      <S.CardNumber>
        <S.CardNumberSpan variant='neutral' modifier='strong' type='4'>
          {cardNumberPart1}
        </S.CardNumberSpan>
        <Span variant='neutral' modifier='strong' type='4'>
          {cardNumberPart2}
        </Span>
      </S.CardNumber>
    );
  }
  return null;
};
